module.exports = __webpack_public_path__ + "img/tile-roof.4fe20b7a.jpg";